<div class="auth-page">
  <div class="auth-card" [class.auth-card--with-back]="!showResetPassword">
    @if (!showResetPassword) {
      <a class="auth-back-button" routerLink="/login">
        <i class="bi bi-arrow-left"></i>
        Back
      </a>
    }
    <div class="auth-card-inner">
      @if (!showResetPassword) {
        <div class="auth-forgot-panel">
          <div class="auth-visual">
            <p class="auth-visual-kicker">Appstrax</p>
            <h1 class="auth-visual-title">Forgot Password</h1>
            <p class="auth-visual-subtitle">Whoops!</p>
            <div class="auth-visual-deco" aria-hidden="true"></div>
          </div>
          <div class="auth-form">
            <h2 class="auth-form-title">Whoops!</h2>
            <p class="auth-form-lead">Forgot your password?</p>
            <form (ngSubmit)="sendEmail()" #form="ngForm" autocomplete="off">
              <div class="form-group">
                <label for="email" class="visually-hidden">Email</label>
                <div class="input-with-icon">
                  <i class="bi bi-envelope"></i>
                  <input
                    type="email"
                    class="form-control"
                    id="email"
                    name="email"
                    [(ngModel)]="email"
                    placeholder="Email"
                    required
                  />
                </div>
              </div>
              @if (errorMessage) {
                <div class="alert alert-danger mb-3">
                  {{ errorMessage }}
                </div>
              }
              <button
                class="btn btn-primary auth-submit"
                type="submit"
                [disabled]="!isSendEmailFormValid()"
                [ngClass]="{ disabled: isLoading }"
              >
                @if (isLoading) {
                  <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                }
                <span class="ms-2" role="status">Send reset email</span>
              </button>
            </form>
          </div>
        </div>
      }
      @if (showResetPassword) {
        <div class="auth-forgot-panel">
          <div class="auth-visual">
            <p class="auth-visual-kicker">Appstrax</p>
            <h1 class="auth-visual-title">Reset Password</h1>
            <p class="auth-visual-subtitle">to continue</p>
            <div class="auth-visual-deco" aria-hidden="true"></div>
          </div>
          <div class="auth-form">
            <h2 class="auth-form-title">Reset Password</h2>
            <p class="auth-form-lead">Reset your password</p>
            <form (ngSubmit)="resetPassword()" #form="ngForm" autocomplete="off">
              <div class="form-group">
                <label for="reset-email" class="visually-hidden">Email</label>
                <div class="input-with-icon">
                  <i class="bi bi-envelope"></i>
                  <input
                    type="email"
                    class="form-control"
                    id="reset-email"
                    name="email"
                    [(ngModel)]="email"
                    placeholder="Email"
                    required
                  />
                </div>
              </div>
              <div class="form-group">
                <label for="code" class="visually-hidden">Code</label>
                <div class="input-with-icon">
                  <i class="bi bi-code"></i>
                  <input
                    type="text"
                    class="form-control"
                    id="code"
                    name="code"
                    [(ngModel)]="code"
                    placeholder="Code"
                    required
                  />
                </div>
              </div>
              <div class="form-group">
                <label for="password" class="visually-hidden">Password</label>
                <div class="input-with-icon">
                  <i class="bi bi-lock"></i>
                  <input
                    type="password"
                    class="form-control"
                    id="password"
                    name="password"
                    [(ngModel)]="password"
                    placeholder="Password"
                    required
                  />
                </div>
              </div>
              @if (errorMessage) {
                <div class="alert alert-danger mb-3">
                  {{ errorMessage }}
                </div>
              }
              <button
                class="btn btn-primary auth-submit"
                type="submit"
                [disabled]="!isResetPasswordFormValid()"
                [ngClass]="{ disabled: isLoading }"
              >
                @if (isLoading) {
                  <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                }
                <span class="ms-2" role="status">Reset password</span>
              </button>
            </form>
          </div>
        </div>
      }
    </div>
  </div>
</div>
